import { Box, Checkbox, CheckboxProps, useTheme } from '@mui/material';
import { useEffect, useRef } from 'react';

type Props = {
  indeterminate?: boolean;
  inHeader?: boolean;
} & CheckboxProps;

/** Row / header checkbox for pending month stacked tables (no monthly-status side border). */
export function MonthTimesheetRowCheckbox({ indeterminate, inHeader, ...rest }: Props) {
  const ref = useRef<HTMLInputElement>(null);
  const { colors } = useTheme();

  useEffect(() => {
    if (typeof indeterminate === 'boolean' && ref.current) {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [indeterminate, rest.checked]);

  return (
    <Box
      {...(inHeader ? { pl: '4px' } : { pl: '12px' })}
      maxHeight={48}
      minHeight={48}
      display='flex'
      alignItems='center'
    >
      <Checkbox
        inputRef={ref}
        indeterminate={indeterminate}
        sx={{
          color: colors.border.default,
          '&.Mui-checked': { color: colors.textAccent.default },
        }}
        {...rest}
      />
    </Box>
  );
}
